import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Coins } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { rp } from "@/lib/format";

export const FeeSettings = () => {
  const { user } = useAuth();
  const editable = user.role === "superadmin";
  const [fee, setFee] = useState(null);
  const [saved, setSaved] = useState(null);
  useEffect(() => {
    api.get("/admin/fees").then((r) => { setFee(r.data.member_transfer_fee); setSaved(r.data.member_transfer_fee); }).catch(() => {});
  }, []);
  if (fee === null) return null;
  const save = async () => {
    try {
      const r = await api.put("/admin/fees", { member_transfer_fee: fee });
      setSaved(r.data.member_transfer_fee);
      toast.success(`Biaya layanan transfer menjadi ${rp(r.data.member_transfer_fee)}`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5 mt-6 max-w-xl" data-testid="fee-settings">
      <h2 className="font-bold text-slate-900 flex items-center gap-2"><Coins className="h-5 w-5 text-amber-500" /> Biaya Layanan Sistem</h2>
      <p className="text-xs text-slate-500 mt-1">Dikenakan pada setiap transfer antar anggota. Isi 0 untuk menggratiskan.{!editable && " Hanya Super Admin yang dapat mengubah."}</p>
      <label className="text-sm font-semibold block mt-4">Biaya per transfer antar anggota</label>
      <div className="flex gap-3 mt-1.5">
        <Input data-testid="fee-input" inputMode="numeric" disabled={!editable} className="h-11 font-bold max-w-[220px]"
          value={`Rp ${Number(fee).toLocaleString("id-ID")}`} onChange={(e) => setFee(Math.min(1000000, Number(e.target.value.replace(/\D/g, "")) || 0))} />
        {editable && <button onClick={save} disabled={fee === saved} data-testid="fee-save" className="bg-amber-500 hover:bg-amber-600 disabled:opacity-50 text-white font-semibold px-5 rounded-xl">Simpan Biaya</button>}
      </div>
      <p className="text-xs text-slate-500 mt-2" data-testid="fee-current">Berlaku saat ini: <b>{rp(saved)}</b></p>
    </div>
  );
};
